/**
 * MSW handlers — auth domain.
 *
 * Currently mirrors the minimal login-success shape used by
 * `src/tests/mocks/handlers.js`. As additional auth flows gain coverage,
 * add them here and re-export from `../index.js`.
 */
import { http, HttpResponse } from 'msw'

export const authHandlers = [
  http.post('/storeauth/prmlogin', () =>
    HttpResponse.json({
      status: 'SUCCESS',
      ret_msg: '',
      err_code: 0,
      data: {
        id: 15006,
        username: 'user@uniuni.com',
        email: 'user@uniuni.com',
        ip_list: null,
        level: null,
        area: '',
        old_area: null,
        city_id: 1,
        partner_id: 0,
        team: '',
        is_active: 1,
        invalid_attempt: 0,
        token: 'aaa',
        managed_customers_data: [],
      },
    }),
  ),
]
